import React, { useState, useEffect } from "react";

import { Text, ScrollArea, Divider, Loader, Box } from "@mantine/core";
import { useListState } from "@mantine/hooks";

import { DndContext, closestCenter } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { restrictToVerticalAxis, restrictToParentElement } from '@dnd-kit/modifiers';

import FilterDefinitionEditor from "../presentations/filters/FilterDefinitionEditor";
import FilterSortableItem from "../presentations/filters/FilterSortableItem";

import SpaceMemberFilterModel from '../../../models/SpaceMemberFilters';

import { reorderOptions } from "../../../utils/Filters";

export default function Filters({ slug, type }) {
  const [allFilters, handlers] = useListState([]);
  const [filtersLoading, setFiltersLoading] = useState(true);
  const [selectedProperty, setSelectedProperty] = useState(null);

  const FilterModel = type === "filter-members" ? SpaceMemberFilterModel : null;

  useEffect(() => {
    if (!slug) return;
    onFetchFilters();
  }, [slug]);

  const onFetchFilters = () => {
    FilterModel.onFetch(
      slug,
      (data) => {
        if (Array.isArray(data)) {
          handlers.setState(data);
        }
        setFiltersLoading(false);
      },
      (error) => {
        console.log("ERROR FETCH MEMBERS FILTER:: ", error);
        setFiltersLoading(false);
      }
    );
  }

  const handleReorder = (updatedItems) => {
    const order = updatedItems.map((item) => ({
      id: item.id,
      sort_order: item.sort_order
    }));
    if (!Array.isArray(order)) return;
    FilterModel.onReorder(
      slug,
      order,
      (data) => {},
      (error) => {}
    );
  };

  return (
    <ScrollArea spacing="xs" sx={{ height: "90vh" }}>
      <Text weight={500}>Properties</Text>
      {filtersLoading ? (
        <Box sx={{ width: "100%" }} align="center">
          <Loader size="sm" />
        </Box>
      ) : (
        <DndContext
          modifiers={[restrictToVerticalAxis, restrictToParentElement]}
          onDragEnd={({ active, over }) => {
            if (active.id !== over?.id) {
              const oldIndex = allFilters.findIndex((i) => i.id === active.id);
              const newIndex = allFilters.findIndex((i) => i.id === over?.id);
              const updatedItems = reorderOptions(allFilters, oldIndex, newIndex);
              handlers.setState(updatedItems);
              
              handleReorder(updatedItems);
            }
          }}
          collisionDetection={closestCenter}
        >
          <SortableContext items={allFilters.map((i) => i.id)} strategy={verticalListSortingStrategy}>
            {allFilters.map((item) => (
              <FilterSortableItem
                key={item.id}
                id={item.id}
                label={item.name}
                emojicon={item.emojicon}
                onEdit={() => setSelectedProperty(item.id === selectedProperty?.id ? null : item)}
              />
            ))}
          </SortableContext>
        </DndContext>
      )}

      <Divider my="sm" />

      <FilterDefinitionEditor
        slug={slug}
        type={type}
        allFilters={allFilters}
        handlers={handlers}
        selectedProperty={selectedProperty}
        setSelectedProperty={setSelectedProperty}
      />
    </ScrollArea>
  );
}
